import {
	CheckCircle,
	Clock,
	Loader2,
	Lock,
	ShieldX,
	XCircle,
} from "lucide-react";
import type { FC } from "react";

import { StatusBadge, type StatusType } from "src/components/status-badge";
import type { PaymentStatus } from "src/types";

interface Props {
	status: PaymentStatus;
}

const statusConfig: Record<
	PaymentStatus,
	{ label: string; type: StatusType; icon: typeof CheckCircle }
> = {
	pending: { label: "Pending", type: "warning", icon: Clock },
	locked: { label: "Locked", type: "info", icon: Lock },
	inProgress: { label: "In Progress", type: "info", icon: Loader2 },
	success: { label: "Success", type: "success", icon: CheckCircle },
	aml_rejected: { label: "AML Rejected", type: "danger", icon: ShieldX },
	failed: { label: "Failed", type: "error", icon: XCircle },
};

const PaymentStatusLabel: FC<Props> = ({ status }) => {
	const config = statusConfig[status] ?? {
		label: status,
		type: "default" as const,
		icon: Clock,
	};

	return (
		<StatusBadge type={config.type} icon={config.icon}>
			{config.label}
		</StatusBadge>
	);
};

export default PaymentStatusLabel;
